import{useMemo}from"react";export const useRowIds=(rows,onGetRowId)=>useMemo((()=>rows.map(((row,index)=>onGetRowId(row,index)))),[rows,onGetRowId]);